import { useEffect, useRef, useState } from 'preact/hooks';

import { usePlaydeckState } from '@/entities/playdeck/models/playdeck.store';

const ONE_MS_BUT_OPTIMIZED = 50;

export const useGameLoadingTimer = () => {
  const { loadingEndSended } = usePlaydeckState();
  const [elapsedMs, setElapsedMs] = useState(0);

  const intervalRef = useRef<NodeJS.Timeout>(null);
  const startTimeRef = useRef<number>(null);

  useEffect(() => {
    if (!loadingEndSended && !intervalRef.current) {
      startTimeRef.current = Date.now() - elapsedMs;
      intervalRef.current = setInterval(() => {
        setElapsedMs(Date.now() - (startTimeRef.current ?? 0));
      }, ONE_MS_BUT_OPTIMIZED);
    }

    if (loadingEndSended && intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    return () => intervalRef.current && clearInterval(intervalRef.current);
  }, [loadingEndSended]);

  return { elapsedMs };
};
